<template>
  <div class="f-home-box">
    <div :class="['header-box', scrollTopVal > 0 ? 'scrollTopFixed' : '']">
      <!-- <div style="width: 100%;" v-if="scrollTopVal > 0"></div> -->
      <div class="header container">
        <div class="head-logo"><img src="@/assets/index/logo.png"></div>
        <div class="head-menu" @click="showMenu">
          <img src="@/assets/index/menu.svg"/>
        </div>
        <div class="header-right" :class="{'mob':currentResolution == 'mobile' && isMenuShow}">
          <div class="menu-style">
            <a-menu v-model="currents" mode="horizontal">
              <a-menu-item key="topBox" @click="navbar({name:'首页'})">首页</a-menu-item>
              <a-menu-item key="mainBusiness" @click="navbar({name:'主营业务'})">主营业务</a-menu-item>
              <a-menu-item key="advantage" @click="navbar({name:'平台优势'})">平台优势</a-menu-item>
              <a-menu-item key="products" @click="navbar({name:'金彩贷'})">金彩贷</a-menu-item>
              <a-menu-item key="aboutUs" @click="navbar({name:'关于我们'})">关于我们</a-menu-item>
              <!--<a-menu-item key="news" @click="navbar({name:'新闻动态'})">新闻动态</a-menu-item>-->
              <a-menu-item key="foot" @click="navbar({name:'联系我们'})">联系我们</a-menu-item>
            </a-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="topBox" ref="topBox" :style="{ backgroundImage: 'url(' + require('@/assets/index/banner.jpg') + ')' }">
      <div class="topBanner">
        <img class="jcdImg" src="@/assets/index/banner_img.png" alt="">
      </div>
    </div>

    <!--主营业务-->
    <div class="mainBusiness" ref="mainBusiness"
         :style="{ backgroundImage: 'url(' + require('@/assets/index/cbg.jpg') + ')' }">
      <div class="container">
        <div class="mainTit">
          <h1><span>主营</span>业务</h1>
          <p>MAIN BUSINESS</p>
        </div>
        <div class="mainCon">
          <ul>
            <li>
              <img src="@/assets/index/bicon1.png" class="icon"/>
              <img src="@/assets/index/iconbt.png" class="iconbt"/>
              <h3>个人小额信贷</h3>
              <p>个人信用贷款服务，解决个人短期资金需求，可灵活分期</p>
            </li>
            <li>
              <img src="@/assets/index/bicon2.png" class="icon"/>
              <img src="@/assets/index/iconbt.png" class="iconbt"/>
              <h3>小微企业贷款</h3>
              <p>专为小微企业打造的贷款产品，帮助企业解决流动资金问题</p>
            </li>
            <li>
              <img src="@/assets/index/bicon3.png" class="icon"/>
              <img src="@/assets/index/iconbt.png" class="iconbt"/>
              <h3>消费分期贷款</h3>
              <p>为消费者提供用于购买商品或服务的分期付款贷款</p>
            </li>
            <li>
              <img src="@/assets/index/bicon4.png" class="icon"/>
              <img src="@/assets/index/iconbt.png" class="iconbt"/>
              <h3>金融信贷咨询</h3>
              <p>金融信贷相关的咨询服务，帮助用户做出更明智的金融决策</p>
            </li>
            <li>
              <img src="@/assets/index/bicon5.png" class="icon"/>
              <img src="@/assets/index/iconbt.png" class="iconbt"/>
              <h3>金融软件研发与维护</h3>
              <p>金融相关软件的开发和维护，提升金融服务的效率和安全性</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--平台优势-->
    <div class="advantage" ref="advantage"
         :style="{ backgroundImage: 'url(' + require('@/assets/index/logobg1.png') + ')' }">
      <div class="container">
        <div class="mainTit">
          <h1><span>平台</span>优势</h1>
          <p>PLATFORM ADVANTAGES</p>
        </div>
        <div class="mainCon">
          <ul>
            <li>
              <img src="@/assets/index/aicon1.png"/>
              <h3>门槛低</h3>
              <p>满18—59周岁均有机会申请</p>
            </li>
            <li>
              <img src="@/assets/index/aicon2.png"/>
              <h3>额度高</h3>
              <p>最高借款额度达20万</p>
            </li>
            <li>
              <img src="@/assets/index/aicon3.png"/>
              <h3>到账快</h3>
              <p>最快3分钟到账</p>
            </li>
            <li>
              <img src="@/assets/index/aicon4.png"/>
              <h3>更灵活</h3>
              <p>最高可分24期</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--产品展示-->
    <div ref="products">
      <div class="products">
        <div class="container">
          <div class="mainTit">
            <h1><span>产品</span>展示</h1>
            <p>PRODUCT DISPLAY</p>
          </div>
          <div class="mainCon">
            <div class="m_left">
              <div class="pl">
                <img src="@/assets/index/app.png" class="app"/>
                <img src="@/assets/index/xd.png" class="xd"/>
                <p>金彩贷赋能金融机构提质增效，助推普惠金融高质量发展，让更过人享受到安全便捷的金融科技服务。</p>
              </div>

              <!--              <div class="pr">-->
              <!--                <img src="@/assets/index/qr.png" class="qr"/>-->
              <!--                <h3>扫码获取额度<br>最高可借20万</h3>-->
              <!--                <img src="@/assets/index/ys.png" class="ys"/>-->
              <!--              </div>-->
            </div>
            <div class="m_right">
              <img src="@/assets/index/product1.jpg"/>
              <img src="@/assets/index/product2.jpg"/>
              <img src="@/assets/index/mine.png"/>
            </div>
          </div>
        </div>
      </div>

      <!--借款流程-->
      <div class="process" :style="{ backgroundImage: 'url(' + require('@/assets/index/cbg1.jpg') + ')' }">
        <div class="container">
          <div class="mainTit">
            <h1><span>借款</span>流程</h1>
            <p>轻松借款 仅需三步 最快3分钟到账</p>
          </div>
          <div class="mainCon">
            <img src="@/assets/index/process_line.png" class="line"/>
            <ul>
              <li>
                <h3>打开APP</h3>
                <p>点击首页查看额度</p>
              </li>
              <li>
                <h3>确认借款金额</h3>
                <p>输入金额，提交借款申请</p>
              </li>
              <li>
                <h3>实时到账</h3>
                <p>放款至您的收款银行卡</p>
              </li>
            </ul>
            <div class="bt">
              <img src="@/assets/index/process_bt.png"/>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!--关于我们-->
    <div ref="aboutUs">
      <div class="aboutUs">
        <div class="container">
          <div class="mainTit">
            <h1><span>关于</span>我们</h1>
            <p>ABOUT US</p>
          </div>
          <div class="mainCon">
            <div class="m_left">
              <p>
                彩通小贷由赣州市彩通网络小额贷款有限公司作为单一发起人，在赣州市龙南县发起设立，注册资本50000万元，于2017年9月获得江西省小额贷款公司经营许可证。</p>
              <p>
                彩通网络小贷以“贴近社区的精准定位、直接造福广大江西人民群众；辅助江西中小微经济发展、促进群众就业、提高财政税收；以社区+网络小贷创新模式，为江西省树立全国金融创新的先进标杆”优势，打破区域限制，从实地促进金融资本与江西省实体经济的高度融合，以全方位的金融服务助力江西经济社会健康快速发展。</p>
            </div>
            <div class="m_right">
              <img class="xkzImg" src="https://oss.itcait.com/jincdev/webImg/xkz2.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <!--底部导航-->
      <div class="foot">
        <div class="container">
          <div class="foot_left">
            <h3>快捷导航</h3>
            <p v-for="(item,index) in footList" :key="index" @click="navbar(item,index)">
              {{ item.name }}
            </p>
          </div>
          <div class="foot_center">
            <img class="phoneImg" src="https://oss.itcait.com/jincdev/webImg/phone.png" alt="">
            <p>客服热线<strong>400-002-0658 </strong></p>
          </div>
          <!--          <div class="foot_right">-->
          <!--            <img class="qrcode" :src="require('@/assets/index/qr.png')" alt="">-->
          <!--            <p>微信扫一扫下载App</p>-->
          <!--          </div>-->
        </div>
      </div>
    </div>

    <div class="address" ref="foot">
      <div class="bottom-address">
        <img class="addressImg" src="https://oss.itcait.com/jincdev/webImg/address.png" alt="">
        <div class="addressName">江西省赣州市龙南市中央城商务大夏B-1703A</div>
      </div>
      <div class="bottom-name">赣州市彩通网络小额贷款有限公司 <a style="color: #8a8a8c"
                                                                 href="https://beian.miit.gov.cn">赣ICP备17015241号-3</a>
      </div>
    </div>

    <!--右侧浮动-->
    <!-- <div class="float" v-if="showTop" @mouseenter="mouseenter" @mouseleave="mouseleave">
    <img class="navbarImg"  :src="!showRightTab ? 'https://oss.itcait.com/jincdev/webImg/navbar.png' : 'https://oss.itcait.com/jincdev/webImg/selNavbar.png'" />
    <div v-if="showItem" class="itemNavName" v-for="(item,index) in navbarList" :key="index" @click="navbar(item,index)">
      <div>{{ item.name }}</div>
    </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      scrollTopVal: 0,
      showItem: true,
      showTop: false,
      isMenuShow: false,
      showRightTab: false,
      currents: ['topBox'],
      navbarList: [{
        name: '首页'
      },
        {
          name: '关于我们'
        },
        {
          name: '主营业务'
        },
        {
          name: '金彩贷'
        },
        {
          name: '新闻动态'
        },
        {
          name: '联系我们'
        }
      ],
      footList: [{
        name: '首页'
      },
        {
          name: '关于我们'
        },
        {
          name: '主营业务'
        },
        {
          name: '平台优势'
        },
        {
          name: '金彩贷'
        },
        // {
        //   name: '新闻动态'
        // },
        {
          name: '联系我们'
        }
      ],
      advantageList: [{
        img: 'https://oss.itcait.com/jincdev/webImg/mkd.png',
        name: '门槛低',
        content: '满18—59周岁均有机会申请'
      },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/edg.png',
          name: '额度高',
          content: '最高借款额度达20万'
        },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/dzk.png',
          name: '到账快',
          content: '最快5分钟到账'
        },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/glh.png',
          name: '更灵活',
          content: '最高可分24期'
        }
      ],
      SHList: [{
        image: 'https://oss.itcait.com/jincdev/webImg/xxsh.png',
        name: '线上审核'
      },
        {
          image: 'https://oss.itcait.com/jincdev/webImg/rrsh.png',
          name: '人工审核'
        },
        {
          image: 'https://oss.itcait.com/jincdev/webImg/jsfk.png',
          name: '极速放款'
        }
      ], //审核

      classificationList: [{
        img: 'https://oss.itcait.com/jincdev/webImg/gzt.png',
        name: '主营业务'
      },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/jp.png',
          name: '平台优势'
        },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/ggcp.png',
          name: '产品展示'
        },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/zs.png',
          name: '资质荣誉'
        },
        {
          img: 'https://oss.itcait.com/jincdev/webImg/xwgg.png',
          name: '新闻公告'
        }
      ],
      currentResolution: '',
    };
  },

  mounted() {
    this.setCurrentResolution();
    window.addEventListener('resize', this.setCurrentResolution);
    this.$nextTick(() => {
      // 开启滚动条监听
      window.addEventListener("scroll", this.scrollTop, true);
    });
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollTop, true);
    window.removeEventListener('resize', this.setCurrentResolution);
  },

  methods: {
    showMenu() {
      this.isMenuShow = !this.isMenuShow
    },
    setCurrentResolution() {
      const width = window.innerWidth;
      const height = window.innerHeight
      if (width <= 1920 && height <= 1080) {
        this.currentResolution = 'mobile';
      }
      if (width >= 1920 && height > 1080) {
        this.currentResolution = 'tablet';
      }
    },

    // 鼠标移入
    mouseenter() {
      this.showItem = true
      this.showRightTab = true
    },

    // 鼠标移出
    mouseleave() {
      this.showItem = false
      this.showRightTab = false
    },

    // 控制右侧导航栏的显示隐藏
    scrollTop() {
      this.showItem = true
      let elVal = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      let top = Math.floor(elVal)
      this.scrollTopVal = top;
      console.log(elVal, 'elVal')
      if (this.currentResolution == 'tablet') {
        if (elVal < 1180) {
          this.currents = ['topBox']
        } else if (elVal >= 1190 && elVal < 1880) {
          // this.showTop = true
          this.currents = ['mainBusiness']
        } else if (elVal >= 1890 && elVal < 2490) {
          // this.showTop = true
          this.currents = ['advantage']
        } else if (elVal >= 2500 && elVal < 3970) {
          this.currents = ['products']
          // this.showTop = false
          // this.showRightTab = false
        } else if (elVal >= 3980 && elVal < 4300) {
          this.currents = ['aboutUs']
        } else if (elVal >= 4400) {
          this.currents = ['foot']
        }
      } else if (this.currentResolution == 'mobile') {
        if (elVal < 900) {
          this.currents = ['topBox']
        } else if (elVal >= 900 && elVal < 1670) {
          // this.showTop = true
          this.currents = ['mainBusiness']
        } else if (elVal >= 1670 && elVal < 2140) {
          // this.showTop = true
          this.currents = ['advantage']
        } else if (elVal >= 2150 && elVal < 3840) {
          this.currents = ['products']
          // this.showTop = false
          // this.showRightTab = false
        } else if (elVal >= 3840 && elVal < 4350) {
          this.currents = ['aboutUs']
        } else if (elVal >= 4350) {
          this.currents = ['foot']
        }
      }
    },

    navbar(tab, index) {
      // 根据点击的选项卡值来滚动到相应的卡片位置
      switch (tab.name) {
        case '首页':
          this.scrollToCard('topBox');
          // this.showTop = false
          // this.currents = ['topBox']
          break;
        case '关于我们':
          this.scrollToCard('aboutUs');
          // this.showTop = true
          // setTimeout(() => {
          //   this.showItem = false
          //   this.showRightTab = false
          // }, 3000)
          break;
        case '主营业务':
          this.scrollToCard('mainBusiness');
          // this.showTop = true
          // setTimeout(() => {
          //   this.showItem = false
          //   this.showRightTab = false
          // }, 3000)
          break;
        case '平台优势':
          this.scrollToCard('advantage');
          // this.showTop = true
          // setTimeout(() => {
          //   this.showItem = false
          //   this.showRightTab = false
          // }, 3000)
          break;
        case '金彩贷':
          this.scrollToCard('products');
          // this.showTop = true
          // setTimeout(() => {
          //   this.showItem = false
          //   this.showRightTab = false
          // }, 3000)
          break;
        case '新闻动态':
          // this.scrollToCard('resourceQuery');
          break;
        case '联系我们':
          this.scrollToCard('foot');
          // this.showTop = true
          // setTimeout(() => {
          //   this.showItem = false
          //   this.showRightTab = false
          // }, 3000)
          break;
          //你可以在这里添加新的想定位到达的部分
      }
    },

    scrollToCard(refName) {
      // 使用 Vue 的 $refs 来获取卡片元素，并滚动到其位置
      const cardElement = this.$refs[refName];
      if (cardElement) {
        // 使用原生的 scrollIntoView 方法来滚动到元素位置
        cardElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  margin: 0 15%;

  h1, h2, h3, h4, p {
    margin: 0;
    padding: 0;
  }

  ul, li, dl, dt, dd {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

.header-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  transition: all 1s;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .head-logo {
    width: 240px;

    img {
      width: 100%;
      display: block;
    }
  }

  .head-menu {
    display: none;

    img {
      width: 25px;
      display: block;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .menu-style {
      margin-left: 88px;
    }
  }

  .ant-menu-horizontal {
    line-height: 100px !important;
    font-size: 16px;
    border-bottom: 1px solid transparent;
    background: transparent;
    color: #fff;

    .ant-menu-item-selected,
    .ant-menu-submenu-selected,
    .ant-menu-submenu-open,
    .ant-menu-item-open,
    .ant-menu-submenu-active .ant-menu-item-active,
    .ant-menu-submenu:hover,
    .ant-menu-item:hover {
      font-size: 18px;
      color: #FDA933;
      border-bottom: 2px solid #FDA933;
      font-weight: bold;
    }

    // .ant-sub-menu-active>.ant-menu-item-active {
    //   font-size: 18px;
    //   color: #fff;
    //   border-bottom: 2px solid #fff;
    //   font-weight: bold;
    // }
  }


  .ant-menu-item,
  .ant-menu-submenu-title {
    padding: 0 42px;
  }

  .ant-input {
    height: 47px;
    font-size: 17px;
  }

  .ant-input-affix-wrapper {
    font-size: 23px;
  }

  &.scrollTopFixed {
    background-color: rgba(61, 49, 14, .8);
    backdrop-filter: blur(20px);
    // box-shadow: 0px 1px 3px #fff;
    color: #fff;

    .ant-menu-horizontal {
      border-bottom: 1px solid transparent;
      background: transparent;
      color: #fff;

      .ant-menu-item-selected,
      .ant-menu-submenu-selected,
      .ant-menu-submenu-open,
      .ant-menu-item-open,
      .ant-menu-submenu-active,
      .ant-menu-item-active,
      .ant-menu-submenu:hover,
      .ant-menu-item:hover {
        font-size: 18px;
        color: #FDAE34;
        border-bottom: 2px solid #FDAE34;
        font-weight: bold;
      }
    }

    .logoBox > .logo-name {
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      margin-left: 12px;
    }

  }
}

.topBox {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;

  .topBanner {
    max-width: 1200px;
    height: 66%;
    overflow: hidden;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jcdImg {
    height: 100%;
  }
}

.mainTit {
  height: auto;
  overflow: hidden;
  text-align: center;
  margin-bottom: 30px;

  h1 {
    font-size: 40px;
    color: #FF9C18;
    margin-bottom: 10px;
    font-weight: bold;

    span {
      font-weight: normal;
      color: #00000C;
    }
  }

  p {
    font-size: 30px;
    color: #ccc;
    font-weight: normal;
  }

  &::before {
    content: '';
    display: block;
    width: 50px;
    height: 3px;
    overflow: hidden;
    background: #ccc;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

.mianCon {
  height: auto;
  overflow: hidden;
}

.mainBusiness {
  height: auto;
  overflow: hidden;
  // background-image: url("https://oss.itcait.com/jincdev/webImg/banner2.png");
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 0;
  position: relative;

  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  li {
    width: 20%;
    text-align: center;

    img {
      display: block;
      margin: 0 auto;
    }

    .icon {
      width: 40%;
      max-width: 150px;
    }

    .iconbt {
      width: 60%;
      max-width: 200px;
    }

    h3 {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }

    p {
      font-size: 15px;
      color: #888;
      line-height: 1.8;
      margin: 20px auto 0 auto;
      max-width: 220px;
      display: block;
    }
  }
}

.advantage {
  padding: 100px 0;
  background-color: rgba(253, 192, 56, 0.05);
  background-position: -180px -170px;
  background-repeat: no-repeat;
  background-size: auto 450px;
  position: relative;

  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  li {
    width: 25%;
    text-align: center;

    img {
      width: 50%;
      display: block;
      margin: 0 auto;
    }

    h3 {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }

    p {
      font-size: 15px;
      color: #888;
      line-height: 1.8;
      margin: 10px 35px 0 35px;
      max-width: 220px;
      display: block;
      margin: 0 auto;
    }
  }

}

.products {
  width: 100%;
  background: #fff;
  position: relative;
  padding: 100px 0 0 0;

  .mainCon {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 20px;
  }

  .m_left {
    //width: 50%;
    flex: 1;
    height: 550px;
    overflow: hidden;
    border: 1px #FDA933 solid;
    padding: 0px 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .pl {
      flex: 1;
      //width: 50%;
      height: auto;
      overflow: hidden;
      padding-left: 20px;

      img {
        display: block;
      }

      .app {
        width: 85%;
      }

      .xd {
        width: 85%;
        margin: 40px 0;
      }

      p {
        //max-width: 340px;
        font-size: 15px;
        line-height: 2;
      }
    }

    .mine-img {
      width: 340px;
      height: 550px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .pr {
      width: 45%;
      height: auto;
      overflow: hidden;
      background: rgba(253, 192, 56, 0.1);
      padding: 50px 25px 35px 25px;
      text-align: center;

      img {
        display: block;
        margin: 0 auto;
      }

      .qr {
        width: 60%;
        border-radius: 10px;
      }

      h3 {
        font-size: 20px;
        color: #666;
        margin: 20px 0;
      }

      .ys {
        width: 85%;
      }
    }
  }

  .m_right {
    width: 70%;
    //flex: 1;
    height: 550px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-left: 40px;

    img {
      width: 45%;
      margin: 0 20px;
      max-width: 340px;
    }
  }
}

.process {
  height: auto;
  overflow: hidden;
  background-size: auto 100%;
  background-position: right top;
  background-repeat: no-repeat;
  padding: 100px 0 0 0;
  position: relative;

  .mainTit {
    p {
      font-size: 20px;
      color: #333;
    }

    &::before {
      display: none;
    }
  }

  .mainCon {
    img {
      width: 100%;
      display: block;
      margin: 0 auto;
    }

    .line {
      margin: 20px 0;
    }

    .bt {
      padding: 0 4%;
      height: auto;
      overflow: hidden;
    }

    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      margin: 20px 0;

      li {
        width: 33.3%;

        h3 {
          font-size: 24px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
        }

        p {
          font-size: 16px;
          color: #888;
        }
      }
    }
  }
}

.aboutUs {
  height: auto;
  overflow: hidden;
  padding: 100px 0;
  position: relative;

  .mainCon {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 20px;
  }

  .m_left {
    flex: 1;
    height: auto;
    overflow: hidden;
    max-width: 800px;
    padding-top: 40px;

    p {
      font-size: 16px;
      color: #333;
      line-height: 2;
      margin: 20px 0;
      text-indent: 2em;
    }
  }

  .m_right {
    width: 30%;
    margin-left: 30px;

    img {
      width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
}

.foot {
  height: auto;
  overflow: hidden;
  background: #eee;
  padding: 80px 0 50px 0;
  position: relative;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8%;
  }

  .foot_left {
    padding-right: 130px;
    border-right: 1px #ccc solid;

    h3 {
      font-size: 24px;
      font-weight: bold;
      color: #666;
    }

    p {
      font-size: 16px;
      color: #666;
      line-height: 2;
    }
  }

  .foot_center {
    flex: 1;
    margin: 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 50px;
      margin-right: 50px;
      filter: grayscale(100);
    }

    p {
      font-size: 20px;
      color: #666;
      line-height: 2;
      margin: 10px 0;

      strong {
        margin-left: 40px;
        font-weight: bold;
      }
    }
  }

  .foot_right {
    padding-left: 130px;
    border-left: 1px #ccc solid;
    text-align: center;

    img {
      width: 180px;
      border-radius: 10px;
      margin-bottom: 15px;
    }

    p {
      font-size: 16px;
      color: #666;
    }
  }
}

.address {
  width: 100%;
  padding: 30px 0 30px;
  background: #3D310E;

  .bottom-address {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bottom-name {
    color: #8a8a8c;
    font-size: 14px;
    letter-spacing: 0px;
    text-transform: uppercase;
    margin: 10px 0 0 20px;
    text-align: center;
  }

  .addressImg {
    width: 26px;
  }

  .addressName {
    color: rgb(255, 255, 255);
    font-size: 18px;
    letter-spacing: 0px;
    text-align: right;
    text-transform: uppercase;
    margin-left: 20px;
  }
}

@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .container {
    margin: 0 10%;
  }

  .foot {
    .container {
      padding: 0 3%;
    }
  }
}

@media screen and (min-width: 981px) and (max-width: 1440px) {
  .container {
    margin: 0 5%;
  }

  .header {
    .header-right {
      flex: 1;
    }

    .menu-style {
      margin-left: 10% !important;
    }

    .ant-menu-item {
      padding: 0 30px !important;
    }
  }

  .foot {
    .container {
      padding: 0;
    }

    .foot_left {
      padding-right: 90px;
    }

    .foot_right {
      padding-left: 90px;
    }
  }
}

@media screen and (max-width: 980px) {
  .container {
    margin: 0;
    padding: 0 15px;
  }

  .header-box {
    .header {
      flex-wrap: wrap;
    }

    .head-logo {
      width: 38%;
      margin: 10px 0;
    }

    .head-menu {
      display: block;
    }

    .header-right {
      width: 100%;
      display: none;

      &.mob {
        display: block;
      }
    }

    .menu-style {
      margin: 0 !important;
    }

    .ant-menu-horizontal {
      line-height: 50px !important;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::before, &::after {
        display: none;
      }
    }

    .ant-menu-item {
      font-size: 14px !important;
      padding: 0 !important;
    }

    .ant-menu-item-selected {
      font-size: 15px !important;
    }
  }

  .topBanner {
    height: 45% !important;
  }

  .mainTit {
    margin-bottom: 30px;

    h1 {
      font-size: 34px;
      margin-bottom: 5px;
    }

    p {
      font-size: 22px;
    }

  }

  .mainBusiness {
    background-size: cover;
    padding: 70px 0 40px 0;

    ul {
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: center;
    }

    li {
      width: 50%;
      text-align: center;

      .icon {
        width: 40%;
        max-width: 150px;
      }

      .iconbt {
        width: 50%;
        max-width: 200px;
      }

      h3 {
        font-size: 18px;
      }

      p {
        font-size: 14px;
        line-height: 1.6;
        margin: 10px auto 20px auto;
        max-width: 300px;
      }
    }
  }

  .advantage {
    padding: 70px 0 40px 0;
    background-color: rgba(253, 192, 56, 0.05);
    background-position: -180px -170px;
    background-repeat: no-repeat;
    background-size: auto 250px;
    position: relative;

    ul {
      flex-wrap: wrap;
    }

    li {
      width: 50%;

      img {
        width: 60%;
      }

      h3 {
        font-size: 18px;
      }

      p {
        font-size: 14px;
        line-height: 1.6;
        margin: 10px 0px 20px 0px;
        max-width: 220px;
      }
    }
  }

  .products {
    padding: 70px 0 0 0;

    .mainCon {
      flex-wrap: wrap;
      padding-top: 0px;
    }

    .m_left {
      width: 100%;
      height: auto;
      padding: 30px 25px 25px 25px;
      flex-wrap: wrap;
      margin-bottom: 20px;

      .pl {
        width: 100%;
        padding: 0px 0 20px 0;

        .app {
          width: 90%;
        }

        .xd {
          width: 85%;
          margin: 20px 0;
        }

        p {
          max-width: 400px;
          font-size: 14px;
          line-height: 1.8;
        }
      }

      .pr {
        width: 100%;
        padding: 30px 15px 15px 15px;
        text-align: center;

        .qr {
          width: 60%;
        }

        h3 {
          font-size: 16px;
          margin: 15px 0;
        }
      }
    }

    .m_right {
      width: 100%;
      height: auto;
      justify-content: space-between;

      img {
        width: 45%;
        margin: 0 10px;
        max-width: 400px;
      }
    }
  }

  .process {
    background-size: auto 50%;
    background-position: right bottom;
    padding: 50px 0 0 0;

    .mainTit {
      p {
        font-size: 16px;
      }
    }

    .mainCon {
      width: 100%;
      overflow: hidden;
      overflow-x: scroll;

      .line {
        width: 300%;
        margin: 0px 0 10px 0;
      }

      .bt {
        width: 290%;
        padding: 0 0 0 10%;
      }

      ul {
        width: 300%;
        margin: 10px 0;

        li {
          width: 33.3%;

          h3 {
            font-size: 18px;
            margin-bottom: 5px;
          }

          p {
            font-size: 14px;
          }
        }
      }
    }
  }

  .aboutUs {
    padding: 70px 0 40px 0;

    .mainTit {
      margin-bottom: 10px;
    }

    .mainCon {
      flex-wrap: wrap;
      padding-top: 0px;
    }

    .m_left {
      flex: auto;
      width: 100%;
      padding: 0px 5px 0 10px;

      p {
        font-size: 15px;
        line-height: 1.8;
        margin: 10px 0;
      }
    }

    .m_right {
      width: 100%;
      margin: 10px 0 0 0;
    }
  }

  .foot {
    padding: 40px 0 30px 0;

    .container {
      padding: 0 10px;
    }

    .foot_left {
      display: none;
    }

    .foot_center {
      flex: 1;
      margin: 0;

      img {
        width: 30px;
        margin-right: 10px;
        filter: grayscale(100);
      }

      p {
        font-size: 16px;

        strong {
          font-size: 18px;
          margin-left: 0px;
          display: block;
        }
      }
    }

    .foot_right {
      padding: 0 20px 0 30px;
      border-left: 1px #ccc solid;

      img {
        width: 130px;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        color: #666;
      }
    }
  }

  .address {
    padding: 20px 0 20px;

    .bottom-address {
    }

    .bottom-name {
      margin: 10px 0 0 0px;
    }

    .addressImg {
      width: 20px;
    }

    .addressName {
      font-size: 15px;
      margin-left: 10px;
    }
  }

}
</style>